<template>
  <div class="wlx-tea-cerfity-wrapper clearfix">
    <div class="tea-cerfity-img-con fl" v-for="(item,index) in list" :key="index" @click="IsShow(item)">
      <img :src="item" class="cerfity-img-val">
    </div>
    <div v-if="imgShow" style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:3000;background:#808080;">
      <img id="canvasImg" style="width:100%;height:100%;" :src="CertificateCover" @click="imgShow=false;"/>
    </div>
    <div style="text-align: center;" v-if="list.length == 0">
      <img src="../../../assets/images/the-last-new-nodata-imag.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      imgShow:false,
      CertificateCover:"",
    };
  },
  created() {
    this.getCertificateList();
  },
  methods: {
    IsShow(url){
      this.CertificateCover=url;
      this.imgShow=true;
    },
    getCertificateList() {
      let self = this;
      this.$http
        .get("/api/XOrg/teaCertificate/getTeaCertificateList")
        .then(function(res) {
          if (res.code == 1) {
            self.list = res.list;
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-tea-cerfity-wrapper {
  margin: 20px 0 0 30px;
  padding: 20px;
  background: #fff;
  .tea-cerfity-img-con {
    margin: 0 20px 20px 0;
    width: 500px;

    .cerfity-img-val {
      width: 100%;
    }
  }
}
</style>
